import axios from "axios";
import { API_HOST } from "@/core/variables";
import { AgentCreate, AgentTokenRefresh, AgentUpdate } from "@/model";

class AgentRepository {
    find = async (
        page: number,
        size: number,
        active: boolean,
        keyword?: string
    ) => {
        return axios.get(`${API_HOST}/v1/agents/paginate`, {
            params: { active, page, size, keyword }
        });
    };

    read = async (agentId: number) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}`);
    };

    create = async (form: AgentCreate) => {
        return axios.post(`${API_HOST}/v1/agents`, {
            ...form
        });
    };

    update = async (agentId: number, form: AgentUpdate) => {
        return axios.put(`${API_HOST}/v1/agents/${agentId}`, {
            ...form,
            active: true
        });
    };

    refreshToken = async (agentId: number, form: AgentTokenRefresh) => {
        return axios.put(`${API_HOST}/v1/agents/${agentId}`, {
            active: true,
            agent_token: form.agent_token
        });
    };

    deactivate = async (agentId: number) => {
        return axios.put(`${API_HOST}/v1/agents/${agentId}`, {
            active: false
        });
    };

    activate = async (agentId: number) => {
        return axios.put(`${API_HOST}/v1/agents/${agentId}`, {
            active: true
        });
    };

    import = async (agent_id: number, file: any, isCleanImport?: boolean) => {
        let form = new FormData();
        const is_clean_import = isCleanImport ? '1' : '0';
        form.append("is_clean_import", is_clean_import);
        form.append("agent_id", String(agent_id));
        form.append("file", file);

        return axios
            .post(`${API_HOST}/v1/agents/${agent_id}/import`, form)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    export = (agent_id: number) => {
        window.open(`${API_HOST}/v1/agents/${agent_id}/export`);
    };
}

const agentRepository = new AgentRepository();

export default agentRepository;
